<template>
  <div class="current-screenshot">
    <div class="current-screenshot-frame" :key="activeScreenshots.id" :style="tempStyle" v-if="activeScreenshots">
      <img :src="activeScreenshots.image" />
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'CurrentScreenshot',
    props: {
      callSid: {
        type: String
      }
    },

    data: () => ({
      tempStyle: ''
    }),

    computed: {
      ...mapGetters({
        getActiveCallScreenshots: 'screenshots/activeCallScreenshots'
      }),

      activeCallScreenshots() {
        return this.getActiveCallScreenshots(this.callSid)
      },

      activeScreenshots() {
        if(this.activeCallScreenshots) {
          let activeCallScreenshots = [...this.activeCallScreenshots];
          activeCallScreenshots.reverse();
          return activeCallScreenshots.find(screenshot => screenshot.status === 'UPLOADING')
        }
        return null
      }
    },

    watch: {
      activeScreenshots(newVal, oldVal) {
        try {
          if(newVal.id === oldVal.id) {
            return;
          }
        } catch (e) {}

        let video = this.$parent.$el.getElementsByTagName('video')[0];
        if(video) {
          let height = video.clientHeight;
          let elementHeight = video.clientHeight;
          let elementWidth = video.clientWidth;
          let videoHeight = video.videoHeight;
          let videoWidth = video.videoWidth;
          let ratio = elementHeight / videoHeight;
          let scaledWidth = videoWidth * ratio;
          let paddingLeft = Math.round((elementWidth - scaledWidth)/2);
          let minminizedsRatio = 156 / videoHeight;
          let minimizedscreenshotWidth = videoWidth * minminizedsRatio;

          let offsetBottom = document.documentElement.clientHeight - video.offsetTop - height;

          this.tempStyle = `height: ${height}px; width: ${scaledWidth}px; left: ${paddingLeft}px; bottom: ${offsetBottom}px; background-color: transparent; border-color: transparent; padding: 0;`;

          setTimeout(() => {
            this.tempStyle = `width:${minimizedscreenshotWidth}px;`
          }, 100)
        } else {
          let canvas = this.$parent.$el.getElementsByTagName('canvas')[0];
          let height = canvas.clientHeight;
          let elementHeight = canvas.clientHeight;
          let elementWidth = canvas.clientWidth;

          let minminizedsRatio = 156 / elementHeight;
          let minimizedscreenshotWidth = elementWidth * minminizedsRatio;

          let offsetBottom = document.documentElement.clientHeight - canvas.offsetParent.offsetTop - height;
          let offsetLeft = canvas.offsetLeft;

          this.tempStyle = `height: ${height}px; width: ${elementWidth}px; left: ${offsetLeft}px; bottom: ${offsetBottom}px; background-color: transparent; border-color: transparent; padding: 0;`;

          setTimeout(() => {
            this.tempStyle = `width:${minimizedscreenshotWidth}px;`
          }, 100)
        }
      }
    }
  }
</script>

<style lang="scss">
@import "CurrentScreenshot";
</style>
